import { CallToAction, Features, Hero } from "@/sections";

export default function Home() {
  return (
    <>
      <Hero />
      <Features />
      <CallToAction />
    </>
  );
}
